import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { UsersService } from '../../services/users.service';
import { EventEmitterService } from '../../services/event-emitter.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  standalone: false,
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss',
})
export class DeleteAccountComponent implements OnInit {
  formGroup: FormGroup;

  constructor(
    public bsModalRef: BsModalRef,
    private usersService: UsersService,
    private eventEmitterService: EventEmitterService,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
    this.setupForm();
  }

  setupForm() {
    this.formGroup = new FormGroup({
      delete_text: new FormControl('', [
        Validators.required,
        this.deleteTextValidator(),
      ]),
    });
  }

  closeModal() {
    this.bsModalRef.hide();
  }

  buttonClicked() {
    this.formGroup.markAllAsTouched();

    if (this.formGroup.invalid) {
      return;
    }

    this.usersService.deleteAccount().subscribe(
      (response) => {
        console.log('response:');
        console.log(response);
        this.authenticationService.logout();
        this.closeModal();
      },
      (error) => {
        console.log('error:');
        console.log(error);
      },
    );
  }

  deleteTextValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Check if the control's value is "Delete" or "delete", case-insensitive
      if (control.value && control.value.trim().toLowerCase() !== 'delete') {
        return { deleteTextInvalid: true }; // Custom error key
      }
      return null; // If it's valid ("Delete" or "delete")
    };
  }
}
